import { useQuery } from '@tanstack/react-query'

import { useAppConfigStore } from '@/stores/app-store-config/appConfigStore'

import { getNewsletterText } from '../api/getNewsletterText'

export const useNewsletter = () => {
	const { newsLetterListName, newsLetterTextName } = useAppConfigStore()

	return useQuery({
		queryKey: ['GET_NEWSLETTER_TEXT', newsLetterListName, newsLetterTextName],
		queryFn: () => getNewsletterText({ newsLetterListName, newsLetterTextName }),
		staleTime: 5000,
	})
}
